import './CellCommentCornerBadge.css';

interface CellCommentCornerBadgeProps {
  onOpen: (e: React.MouseEvent) => void;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
}

/** Круглый индикатор комментариев: наведение — превью треда, клик — закреплённое окно */
export function CellCommentCornerBadge({
  onOpen,
  onPointerEnter,
  onPointerLeave,
}: CellCommentCornerBadgeProps) {
  return (
    <button
      type="button"
      className="cell-comment-corner-badge"
      aria-label="Посмотреть комментарии к ячейке"
      onClick={onOpen}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
      onPointerDown={(e) => e.stopPropagation()}
    />
  );
}
